module.exports = __webpack_public_path__ + "img/picto-personnes-a-charge.3f4e45b5.svg";